import { outdent } from 'outdent';
import type { DevCenterComponent } from '../../../dev-center/components/dev-center-component.js';
import { getBlocksPathWithHMR } from '../hmr/plugin.js';

export const getBlocksPanelBuildTemplate = (
  blocksPanelComponent: DevCenterComponent<'BlocksWidgetPanel'>
) => {
  return outdent`
    import { enableContext } from '@wix/cli-app/internal/platform-sdk/sdk-context';

    export const init = async function({ $w, wixClient }) {
      enableContext(wixClient, 'module');

      const { default: panelController } = await import('/${blocksPanelComponent.relativePath}');
      await panelController?.($w);
    }
  `;
};

export const getBlocksPanelDevTemplate = (
  blocksPanelComponent: DevCenterComponent<'BlocksWidgetPanel'>
) => {
  return outdent`
    import { enableContext } from '@wix/cli-app/internal/platform-sdk/sdk-context';

    export const init = async function({ $w, onHMRCallback, wixClient }) {
      enableContext(wixClient, 'module');

      const { default: wrappedController } = await import(/* @vite-ignore */ \`${getBlocksPathWithHMR(blocksPanelComponent.relativePath)}\`);
      await wrappedController?.(onHMRCallback, $w);
    }
  `;
};

export const getBlocksWidgetBuildTemplate = (
  blocksWidgetComponent: DevCenterComponent<'BlocksWidget'>
) => {
  return outdent`
    import { enableContext } from '@wix/cli-app/internal/platform-sdk/sdk-context';
    import apiConfig from '/${blocksWidgetComponent.apiPath}';

    export const init = async function({ $w, $widget, wixClient }) {
      enableContext(wixClient, 'module');

      const { default: widgetController } = await import('/${blocksWidgetComponent.relativePath}');
      return await widgetController?.($w, $widget);
    }
    export const api = apiConfig;
  `;
};

export const getBlocksWidgetDevTemplate = (
  blocksWidgetComponent: DevCenterComponent<'BlocksWidget'>
) => {
  return outdent`
    import { enableContext } from '@wix/cli-app/internal/platform-sdk/sdk-context';
    import apiConfig from '/${blocksWidgetComponent.apiPath}';

    export const init = async function({ $w, $widget, onHMRCallback, wixClient, widgetInstanceId }) {
      enableContext(wixClient, 'module');

      const { default: wrappedController } = await import(/* @vite-ignore */ \`${getBlocksPathWithHMR(blocksWidgetComponent.relativePath, 'widgetInstanceId')}\`);
      return await wrappedController?.(onHMRCallback, $w, $widget);
    }
    export const api = apiConfig;
  `;
};
